import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildBrandOverlayEntity } from "@youm-front/brand/utils/factory";
import {
  ROOM_BRAND_OVERLAY_FEATURE_KEY,
  RoomBrandOverlayState
} from "../reducers";

const roomBrandOverlayState = createFeatureSelector<RoomBrandOverlayState>(
  ROOM_BRAND_OVERLAY_FEATURE_KEY
);

export const brandOverlay = createSelector(
  roomBrandOverlayState,
  (state: RoomBrandOverlayState) =>
    state.brandOverlay ? buildBrandOverlayEntity(state.brandOverlay) : null
);

export const isLoading = createSelector(
  roomBrandOverlayState,
  (state: RoomBrandOverlayState) => state.isLoading
);
